import { axios } from 'lib';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

const updateDPSSettingValue = async (dpsId, key, value) => {
  return axios.patch(
    `/api/dps/${dpsId}/settings/${key}`,
    JSON.stringify({ value: String(value) })
  );
};

export const useUpdateDPSSettingValue = (dpsId, key) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (value) => updateDPSSettingValue(dpsId, key, value),
    onSuccess: () => {
      enqueueSnackbar('Setting was successfully updated', { variant: 'success' });
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
